module.exports = __webpack_public_path__ + "static/media/DWCaslon.8cda8e95.woff2";